
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/studio/modernization",
      function () {
        return require("private-next-pages/services/studio/modernization.tsx");
      }
    ]);
  